import React from 'react';
import { MoonIcon, PaletteIcon, SunIcon } from 'lucide-react';
import { ThemeId, useTheme } from '../../contexts/ThemeContext';
const OPTIONS: Array<{
  id: ThemeId;
  label: string;
  Icon: typeof MoonIcon;
}> = [{
  id: 'dark',
  label: 'Dark theme',
  Icon: MoonIcon
}, {
  id: 'light',
  label: 'White theme',
  Icon: SunIcon
}, {
  id: 'color',
  label: 'Colourful theme',
  Icon: PaletteIcon
}];
export function ThemeSwitcher() {
  const {
    theme,
    setTheme
  } = useTheme();
  return <div role="radiogroup" aria-label="Theme" className="flex items-center rounded-full border border-line p-0.5" data-id="element-260" data-mp="3j6m9e84phafj">
      {OPTIONS.map(({
      id,
      label,
      Icon
    }) => {
      const active = id === theme;
      return <button key={id} type="button" role="radio" aria-checked={active} aria-label={label} title={label} onClick={() => setTheme(id)} className={`inline-flex h-5 w-6 items-center justify-center rounded-full transition-colors duration-150 ease-out ${active ? 'bg-machine text-bg' : 'text-muted hover:text-ink'}`} data-id="element-261" data-mp="39g9r6mkd5tck">
            <Icon className="h-3 w-3" aria-hidden="true" data-id="element-262" data-mp="35xd6hm2uao8w" />
          </button>;
    })}
    </div>;
}